"use client";

import { useGetBlog } from "@/hooks/main-hook";
import { useLocale } from "next-intl";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { BlogDetailSkeleton } from "../loading/mainLoading";

export default function MainBlog({ slug }: { slug: string }) {
  const locale = useLocale();
  const navigate = useRouter();
  const { data, isLoading, isError } = useGetBlog(slug);

  const blog = data?.blog;

  if (isError) {
    navigate.push("/blog");
    return null;
  }

  if (isLoading) {
    return <BlogDetailSkeleton />;
  }

  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <div className="relative w-full h-100 md:h-150 overflow-hidden rounded-2xl shadow-lg mb-10">
        {blog?.image ? (
          <Image
            src={blog.image}
            alt="Blog Image"
            fill
            className="object-cover"
            priority
          />
        ) : null}
      </div>

      <div className="space-y-12">
        <div className="border-b pb-6">
          <div
            className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4 leading-tight"
            dangerouslySetInnerHTML={{
              __html:
                locale === "ar"
                  ? blog?.title?.ar || blog?.title?.en
                  : blog?.title?.en || blog?.title?.ar,
            }}
          />
        </div>

        <div className="bg-gray-50 p-6 rounded-xl border-l-4 border-blue-500 shadow-sm">
          <div
            className="text-xl text-gray-700 font-medium mb-4"
            dangerouslySetInnerHTML={{
              __html:
                locale === "ar"
                  ? blog?.description?.ar || blog?.description?.en
                  : blog?.description?.en || blog?.description?.ar,
            }}
          />
        </div>

        <article className="prose prose-lg md:prose-xl max-w-none prose-headings:text-blue-700 prose-strong:text-black prose-img:rounded-xl">
          <div className="bg-white p-4 rounded-lg">
            <div
              dangerouslySetInnerHTML={{
                __html:
                  locale === "ar"
                    ? blog?.blog?.ar || blog?.blog?.en
                    : blog?.blog?.en || blog?.blog?.ar,
              }}
            />
          </div>
        </article>
      </div>
    </div>
  );
}
